import { render, staticRenderFns } from "./AreaConcessao.vue?vue&type=template&id=28f13b16&"
import script from "./AreaConcessao.vue?vue&type=script&lang=js&"
export * from "./AreaConcessao.vue?vue&type=script&lang=js&"
import style0 from "./AreaConcessao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports